import { render, staticRenderFns } from "./LandList.vue?vue&type=template&id=24f9ba90&scoped=true&"
import script from "./LandList.vue?vue&type=script&lang=js&"
export * from "./LandList.vue?vue&type=script&lang=js&"
import style0 from "./LandList.vue?vue&type=style&index=0&id=24f9ba90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f9ba90",
  null
  
)

export default component.exports